<template>
    <header ref="container" :class="['header', pageSettings.fill, menu.active ? 'active' : '']">
        <div class="container">
            <div class="row between nowrap proverka">
                <div class="col d2 md-4 header__col header__logo">
                    <a :href="params.logo.url" v-html="params.logo.img"></a>
                </div>
                <div :class="{'col d12 menu': true, active: menu.active}" ref="menuNode" v-show="params.show">
                    <div class="row v-center nowrap menu__inner">
                        <div :class="{'col d12 header__col header__menu menu__panel': true, 'no-scroll': menu.noScroll}">
                            <div class="nav">
                                <div class="nav__inner">
                                    <ul class="nav__list nolist">
                                        <li class="nav__item" v-for="(item, i) in params.menu" :key="i">
                                            <a :href="item.url" class="nav__link"
                                               @click="menuLevelShow($event)">{{ item.title }}</a>
                                            <div v-if="item.children && item?.children?.items?.length > 0"
                                                 class="nav__level nav__dropdown">
                                                <div class="nav__level-inner nav__dropdown-inner">
                                                    <div class="nav__level-row flex">
                                                        <div class="nav__level-col nav__level-col-left d7 md-6 sm-12">
                                                            <div class="nav__level-header">
                                                                <div class="nav__level-back-btn"
                                                                     @click="menuLevelHide($event)">
                                                                  {{ params.messages.back }}
                                                                </div>
                                                                <div class="nav__level-title h2">{{ item.title }}</div>
                                                            </div>
                                                            <ul class="nav__level-list nolist nomargin">
                                                                <li class="nav__level-item just-mobile">
                                                                  <a :href="item.url" class="nav__level-link">{{ item.title }}</a>
                                                                </li>
                                                                <li class="nav__level-item"
                                                                    v-for="(item_2, ii) in item.children.items"
                                                                    :key="ii">
                                                                    <a :href="item_2.url"
                                                                       class="nav__level-link">{{ item_2.title }}</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div class="nav__level-col nav__level-col-right d5 md-6" v-if="item.children">
                                                            <div class="nav__level-col-inner">
                                                                <div class="nav__level-banner">
                                                                    <div class="nav__level-banner-inner"
                                                                         :style="`background-image: url('${item?.children?.banner?.image}')`">
                                                                        <div class="nav__level-banner-content">
                                                                            <div class="nav__level-banner-content-inner">
                                                                                <div class="nav__level-content-top" v-if="item?.children?.banner">
                                                                                    <div class="nav__level-banner-title">
                                                                                        {{ item?.children?.banner?.title }}
                                                                                    </div>
                                                                                    <div class="nav__level-banner-text">
                                                                                        {{ item?.children?.banner?.text }}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="nav__level-banner-actions" v-if="item?.children?.banner?.btn">
                                                                                    <ABtn :href="item.children.banner.btn.link" :label="item.children.banner.btn.title" class="dark nav__level-banner-btn"></ABtn>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="nav__item langs" v-if="params.langs.length>0">
                                            <a href="/#" class="nav__link" @click="menuLevelShow($event)">
                                                <span class="nav__link-title">{{ params.messages.language }}</span>
                                                <span class="nav__link-desc testS">{{ currentLang.name }}</span>
                                            </a>
                                            <div class="nav__level nav__dropdown">
                                                <div class="nav__level-inner nav__dropdown-inner">
                                                    <div class="nav__level-row flex">
                                                        <div class="nav__level-col d7 sm-12">
                                                            <div class="nav__level-header">
                                                                <div class="nav__level-back-btn"
                                                                     @click="menuLevelHide($event)">
                                                                    {{ params.messages.back }}
                                                                </div>
                                                                <div class="nav__level-title h2">
                                                                    {{ params.messages.language }}
                                                                </div>
                                                            </div>
                                                            <ul class="nav__level-list nolist nomargin">
                                                                <li class="nav__level-item"
                                                                    v-for="(item, i) in params.langs" :key="i">
                                                                    <a :href="item.url"
                                                                       class="nav__level-link">{{ item.title }}</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col header__col header__actions">
<!--                            <div class="langs dropdown">
                                <div class="dropdown__btn langs__current">{{ currentLang.title }}</div>
                                <div class="dropdown__panel langs__dropdown">
                                    <div class="dropdown__panel-inner">
                                        <template v-for="(item, i) in params.langs">
                                            <a :href="item.url" class="dropdown__item langs__item" :key="i"
                                               v-if="!item.current">{{ item.title }}</a>
                                        </template>
                                    </div>
                                </div>
                            </div>-->
                            <ABtn v-if="!params.user" :label="params.messages.logIn" href="#" class="dark login-btn" fill="outlined" @click.native.prevent="openLoginForm"/>
                            <ABtn v-if="params.user" :label="params.messages.logOut" :href="params.user.logoutLink" class="dark login-btn" fill="outlined"/>
                            <ABtn v-if="!params.user" :label="params.messages.register" class="dark register-btn" @click="showRegisterModal"/>

                            <div @click="spanClick">
                            <span class="header__user flex v-center hlink" v-if="params.user">
                              <div class="header__user-welcome">
                                <span class="header__user-welcome-text">{{ params.messages.greetings }}, </span>
                                <span class="header__user-welcome-name">{{ params.user.name }}</span>
                              </div>
                              <div class="avatar_vrap">
                                <a-avatar
                                    :src="params.user.photo.src"
                                    :alt="params.user.photo.alt"
                                    :title="params.user.photo.title"
                                    width="50" />
                                <NewMessageIdent :params="params.user.chat"/>
                              </div>
                            </span>
                                <AsideNav class="header__user-menu" id="header__user-menu_for_mob" v-if="leftMenu === true" :items="params.account.menu"></AsideNav>
                            </div>


                          <form class="search__form" v-if="params.search.action" :action="params.search.action" :method="params.search.method">
                                <div class="flex v-center search__form-wrap">
                                    <input class="search__input" type="text" :name="params.search.qvar" value=""
                                           :placeholder="params.search.placeholder">
                                    <ABtn class="search__btn secondary">
                                        <template #content>{{ params.search.btn }}</template>
                                        <template #after>
                                            <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M15.0505 14.5703L11.4651 10.6094C12.3547 9.48321 12.8559 8.06834 12.886 6.59859C12.9161 5.12884 12.4731 3.69219 11.6304 2.52601C10.7877 1.35984 9.59557 0.533944 8.25111 0.184796C6.90664 -0.164353 5.49026 -0.0158568 4.236 0.605745C2.98175 1.22735 1.96468 2.28485 1.35287 3.60352C0.741063 4.92219 0.571121 6.4231 0.871129 7.85824C1.17114 9.29339 1.92314 10.5769 3.00288 11.4966C4.08261 12.4164 5.42546 12.9173 6.80953 12.9167C8.05713 12.92 9.27486 12.5114 10.2942 11.7473L13.907 15.7415C13.9792 15.8213 14.0655 15.8851 14.161 15.9294C14.2564 15.9738 14.3592 15.9977 14.4633 15.9998C14.5675 16.002 14.671 15.9823 14.768 15.942C14.865 15.9016 14.9536 15.8414 15.0287 15.7647C15.1037 15.688 15.1639 15.5963 15.2056 15.4949C15.2473 15.3936 15.2698 15.2844 15.2719 15.1738C15.2739 15.0632 15.2554 14.9532 15.2174 14.8502C15.1794 14.7471 15.1227 14.6531 15.0505 14.5733V14.5703ZM6.80897 1.6804C7.69822 1.6804 8.5675 1.96048 9.30689 2.48523C10.0463 3.00997 10.6226 3.75582 10.9629 4.62844C11.3032 5.50106 11.3922 6.46127 11.2187 7.38764C11.0452 8.31401 10.617 9.16494 9.98821 9.83281C9.35942 10.5007 8.55828 10.9555 7.68612 11.1398C6.81396 11.3241 5.90994 11.2295 5.08838 10.868C4.26682 10.5066 3.56462 9.89448 3.07058 9.10914C2.57654 8.3238 2.31284 7.40049 2.31284 6.45597C2.31417 5.18985 2.7883 3.97598 3.6312 3.08069C4.4741 2.18541 5.61693 1.68181 6.80897 1.6804Z"
                                                    fill="#E2E2E2"/>
                                            </svg>
                                        </template>
                                    </ABtn>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ABtn v-if="params.back.show&&subHeader.backLink" class="back-btn" :label="params.messages.backLong"
                      :href="subHeader.backLink" fill="flat"/>
                <div class="header__actions-mob flex v-center menu-toggle">
                    <ABtn @click="menuToggle" :class="{active: menu.active}">
                        <template #content>
                            <div class="icon">
                                <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 0H0V2H20V0Z"></path>
                                </svg>
                                <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 0H0V2H20V0Z"></path>
                                </svg>
                                <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 0H0V2H20V0Z"></path>
                                </svg>
                            </div>
                        </template>
                    </ABtn>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

import {computed, ref, onMounted, provide, nextTick} from 'vue'
import {useStore} from 'vuex'
import { ABtn, useAModal, AAvatar } from '../ui'
import {useHeader} from "../../composables/useHeader";
import {NewMessageIdent} from "../../components/chat/NewMessageIdent.vue";
import {usePageSettings} from "../../composables/usePageSettings";
import {AUTH_STATES} from "../../store/modules/auth";
import AsideNav from "../AsideNav.vue";

export default {
    name: 'AppHeader',
    components: {
        ABtn,
        AAvatar,
        NewMessageIdent,
        AsideNav
    },
    props: {
        params: {
            type: Object,
            default: () => {
            }
        }
    },
    setup: (props, ctx) => {
        const $store = useStore()
        const menuNode = ref(null);
        const container = ref(null);
        const leftMenu = ref(null);
        const menu = ref({
            noScroll: false,
            active: false,
            isSticky: false,
            el: null,
        })
        
        $store.commit('global/setGlobalMessages', props.params.messages)

        const spanClick = () => {
            leftMenu.value = true;
        }
        const handleClickOutside = (event) => {
            const headerUserElement = document.querySelector('.header__user');
            if (headerUserElement && !headerUserElement.contains(event.target)) {
                leftMenu.value = false; // Если клик был сделан вне .header__user, переключаем leftMenu на false
            }
        };

        onMounted(() => {
            document.addEventListener('click', handleClickOutside);
        });

        const currentLang = computed(() => props.params.langs.find((el) => el.current))

        const {subHeader} = useHeader();
        const {pageSettings} = usePageSettings();


        const menuToggle = () => {
            menu.value.active = !menu.value.active
            const topBanner = document.querySelector('.top-page-banner')
            const header = document.querySelector('.header')

            if (menu.value.active) {

                menu.value.isSticky = header.classList.contains('sticky')

                let h = 0

                if (topBanner) {
                    const topBannerHeight = topBanner.getBoundingClientRect().height
                    h = h + window.scrollY < topBannerHeight ? topBannerHeight - window.scrollY : 0
                }
                if (header) {
                    h = h + header.getBoundingClientRect().height
                }

                menuNode.value.style.height = `calc(100vh - ${h}px)`
                document.body.style.width = '100%'
                document.body.style.height = '100%'
                document.body.style.overflow = 'hidden'

                setTimeout(() => {
                    props.params.fill === 'secondary' && header.classList.remove('secondary')
                })

            } else {
                document.body.style.width = null
                document.body.style.height = null
                document.body.style.overflow = null

                setTimeout(() => {
                    console.log(menu.value.isSticky)
                    // props.params.fill === 'secondary' && !menu.value.isSticky && header.classList.add('secondary')
                    if (menu.value.isSticky) {
                        header.classList.add('sticky')
                        header.classList.remove('secondary')
                    }
                });
            }
        }

        const menuLevelShow = (e) => {

            const parent = e.currentTarget.closest('.nav__item')
            const level = parent.querySelector('.nav__level')

            if (level) {
                if (document.documentElement.clientWidth <= 768) {
                    e.preventDefault()
                    level.classList.add('active')
                    menu.value.noScroll = true
                } else if (document.documentElement.clientWidth <= 1024) {
                    e.preventDefault()
                }
            }
        }

        const menuLevelHide = (e) => {
            e.currentTarget.closest('.nav__level').classList.remove('active')
            menu.value.noScroll = false
        }

        const modal = useAModal()
        const showRegisterModal = () => {
            modal.show('authPage-modal')
            $store.commit('auth/setAuthState', AUTH_STATES.registration)
        }

        const openLoginForm = () => {
            modal.show('authPage-modal')
            $store.commit('auth/setAuthState', AUTH_STATES.login)
        }

        onMounted(() => {
          setTimeout(()=>{
            window.replaceHLink(container.value);
          },800);


            const header = document.querySelector('.header')
            window.addEventListener('scroll', (e) => {
                if (pageSettings.fill === 'secondary') {
                    const topBanner = document.querySelector('.top-page-banner')
                    const hero = document.querySelector('.page-hero')
                    const topBannerHeight = topBanner ? topBanner.getBoundingClientRect().height : 0
                    const heroHeight = hero ? hero.getBoundingClientRect().height : 0
                    const h = topBannerHeight + heroHeight

                    if (window.scrollY > h) {
                        header.classList.remove('secondary')
                        header.classList.add('sticky')
                    } else {
                        header.classList.add('secondary')
                        header.classList.remove('sticky')
                    }
                } else {
                    window.scrollY > 60 ? header.classList.add('sticky') : header.classList.remove('sticky')
                }
            })
        });
        return {
            menuNode,
            container,
            menu,
            currentLang,
            subHeader,
            pageSettings,
            menuToggle,
            menuLevelShow,
            menuLevelHide,
            showRegisterModal,
            openLoginForm,
            leftMenu,
            spanClick
        }
    },
}
</script>

<style lang="scss">
.avatar_vrap {
  position: relative;
}
.app-header {
    position: sticky;
    z-index: 200;
    top: 0;
}

.header {
    width: 100%;
    height: 100px;
    background: transparent;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    z-index: 100;
    transition: all .3s ease 0s;
    border-bottom: 1px solid transparent;

    .back-btn {
        color: #fff;
        @include mobile {
            display: none;
        }
    }
.just-mobile {
  display: none;
  @include mobile {
    display: list-item;
  }
}
    &__user {
        margin-left: 30px;
        color: var(--c-gray-120);
        @include mobile {
            margin-left: 0;
        }

        &:hover {
            text-decoration: none;
            color: var(--c-primary-200);
        }
        &-welcome {
            font-size: 14px;
            line-height: 20px;
            white-space: nowrap;
            &-text {
                font-weight: 400;
                @include tablet {
                    display: none;
                }

                @include mobile {
                    display: inline;
                }
            }
            &-name {
                font-weight: 600;
            }
        }
        .a-avatar {
            margin-left: 16px;
        }
    }

    &.white,
    &.secondary.white{
        background: #fff;
        border-bottom: 1px solid var(--c-gray-700);
        @include mobile {
            border-color: transparent;
        }
    }

    &.sticky,
    &.secondary.sticky,
    &.secondary.white,
    &.sticky.white {
        background: #fff;
        border-color: var(--c-gray-800);
        color: var(--c-gray-100);
      .menu {
        &-toggle {
          .a-btn {
            color: var(--c-secondary-200);
          }
        }
      }
        .header {
            a {
                color: var(--c-gray-100);
            }
            &__logo {
                filter: none !important;
            }

        }
        .back-btn {
            color: #000;
        }
        .nav__link {
          color: var(--c-gray-100);
        }
        .a-btn.dark.outlined.dark {
          color: var(--c-gray-100);
        }
      .header__actions .a-btn.dark:not(.outlined) {
        background: var(--c-gray-100);
        color: #fff;
      }
    }
    &.page_type_secondary {
      .back-btn {
        color: var(--c-gray-100);
      }
    }
    &.secondary {
        background: var(--c-secondary-200);
        color: #fff;
        border-bottom: 1px solid rgb(233, 235, 237, 0.1);
        .header {
            &__logo {
                filter: saturate(0.1) brightness(10);
            }

            &__actions {
                .a-btn.outlined.dark {
                    color: #fff;
                    background: transparent;

                    &::before {
                        display: block;
                        background: currentColor;
                    }

                    &:hover {
                        &::before {
                            opacity: .2;
                        }
                    }
                }

                .a-btn.dark {
                    background: #fff;
                    color: var(--c-secondary-200);

                    &::before {
                        background: var(--c-gray-700);
                    }
                }
            }
        }

        .nav {
            &__link {
                color: #fff;

                &:hover {
                    border-color: #fff;
                }
            }
        }

        .menu {
            &-toggle {
                .a-btn {
                    color: #fff;
                }
            }
        }
    }

        @include tablet {
            height: 80px;
            padding: 9px 0;
        }
        @include mobile {
            height: 55px;
            padding: 10px 0;
            border-bottom: 1px solid transparent;
            &.active {
                background: var(--c-gray-800);
                border-color: var(--c-gray-700);
            }
        }

    .container {
        max-width: 1504px;
    }

    &__col {
        display: flex;
        align-items: center;
    }

    &__actions {
        @include tablet {
            padding-left: 0;
        }

        .a-btn {
            margin-left: 10px;

            @include tablet {
                padding: 12px;
            }

            &:first-child {
                margin-left: 0;
            }
        }
    }

    &__logo {
        transition: all .3s ease 0s;
        @include tablet {
            width: 80px;
            min-width: 80px;
        }
    }

    &__actions {
        @include mobile {
            width: 100%;
            justify-content: center;
            padding: 16px;
            flex-wrap: wrap;
            > .a-btn {
                width: calc(50% - 5px);
                margin: 0;
            }
            .login-btn {
                margin-right: 5px;
            }
            .register-btn {
                margin-left: 5px;
            }
        }

        .search__form {
            display: none;
            @include mobile {
                display: block;
                width: 100%;
                margin-top: 16px;
            }
        }
    }
}

.menu {
    @include mobile {
        position: absolute;
        left: 0;
        top: 55px;
        width: 100%;
        height: calc(100vh - 55px);
        padding: 0;
        transition: transform .3s ease 0s;
        transform: translate(-100%, 0);
        display: block !important;
        & > .row {
            height: 100%;
            margin: 0;
        }
        &.active {
            transform: translate(0, 0);
        }
    }

    &-toggle {
        display: none;
        @include mobile {
            display: inherit;
        }

        .a-btn {
            padding: 0;
            width: 40px;
            height: 34px;
            background: transparent;
            position: relative;
            color: #000;

            .icon {
                display: inline-flex;
                width: 20px;
                margin: auto;
            }

            svg {
                position: absolute;
                fill: currentColor;
                transition: opacity 0.15s ease, top 0.15s ease 0.15s,
                bottom 0.15s ease 0.15s, transform 0.15s ease 0s;

                &:nth-child(1) {
                    top: 18px;
                }

                &:nth-child(2) {
                    top: 0;
                    bottom: 0;
                    margin: auto;
                }

                &:nth-child(3) {
                    bottom: 18px;
                }
            }

            &.active {
                svg {
                    fill: var(--c-secondary-200);
                    transition: top 0.15s ease, bottom 0.15s ease,
                    transform 0.15s ease 0.15s;

                    &:nth-child(1) {
                        top: 50%;
                        transform: rotate(45deg);
                    }

                    &:nth-child(2) {
                        opacity: 0;
                    }

                    &:nth-child(3) {
                        bottom: 10px;
                        transform: rotate(-45deg);
                    }
                }
            }
        }
    }

    &__panel {
        @include mobile {
            align-items: flex-start;
            padding: 0;
            z-index: 100;
            height: calc(90% - 150px);
            overflow: auto;
            &.no-scroll {
                overflow: hidden;
            }
        }
    }

    &__inner {
        @include mobile {
            flex-wrap: wrap;
            width: 100%;
            background: var(--c-gray-800);
            height: 100%;
            max-height: 100%;
            flex-direction: column;
            justify-content: flex-start;
        }
    }
}

.nav {
    width: 100%;
    z-index: 1;

    &__list {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        @include tablet {
            justify-content: space-between;
            width: 100%;
        }
        @include mobile {
            width: 100%;
            flex-direction: column;
            align-items: flex-start;
        }
    }

    &__item {
        font-size: 14px;


        &.langs {
            display: none;
            @include mobile {
                display: inherit;
            }
        }

        @media screen and (max-width: 1366px) {
            margin-left: 5%;
            font-size: 14px;
        }

        @media screen and (max-width: 1200px) {
            margin-left: 1%;
            font-size: 14px;
        }

        @include tablet {
            margin-left: 0;
            font-size: 12px;
        }
        @include mobile {
            margin-left: 0;
            font-size: 14px;
            font-weight: 600;
            width: 100%;
        }

        &:first-child {
            margin-left: 0;
        }

        &:hover {
            .nav__dropdown {
                opacity: 1;
                visibility: visible;
            }
        }
    }

    &__link {
        font-weight: 600;
        color: var(--c-gray-100);
        white-space: nowrap;
        display: inline-flex;
        padding: 8px 16px;
        border-radius: 6px;
        border: 1px solid transparent;

        @include tablet {
            padding: 8px;
        }
        @include mobile {
            width: 100%;
            border-radius: 0;
            padding: 15px;
            border: none;
            border-bottom: 1px solid var(--c-gray-700);
            align-items: center;
            justify-content: space-between;
            &-desc {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
            }
        }

        &:hover {
            border-color: var(--c-gray-600);
            text-decoration: none;
        }
    }

    &__level {
        color: var(--c-gray-100);

        &-header {
            padding-top: 46px;
            margin-bottom: 54px;
            @include tablet {
                padding-top: 0;
                margin-bottom: 40px;
            }
            @include mobile {
                padding: 15px 15px 22px 15px;
                margin-bottom: 0;
                border-bottom: 1px solid var(--c-gray-700);
            }
        }

        &-back-btn {
            display: none;
            @include mobile {
                display: inline-flex;
                font-size: 12px;
                line-height: 16px;
                color: var(--c-gray-400);
                margin-bottom: 6px;
                font-weight: 400;
            }
        }

        &-title {
            margin: 0;
        }

        &-list {
            columns: 2;
            -webkit-columns: 2;
            -moz-columns: 2;
            margin-bottom: -28px;
            @include mobile {
                columns: initial;
                -webkit-columns: initial;
                -moz-columns: initial;
                margin-bottom: 0;
            }
        }

        &-item {
            margin-bottom: 28px;
            font-weight: 600;
            @include mobile {
                margin-bottom: 0;
            }
        }

        &-link {
            color: var(--c-gray-100);

            &:hover {
                color: var(--c-primary-200);
            }

            @include mobile {
                display: inline-flex;
                width: 100%;
                border-radius: 0;
                padding: 15px;
                border: none;
                border-bottom: 1px solid var(--c-gray-700);
                align-items: center;
                justify-content: space-between;
                &-desc {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
        }

        &-col-right {
            @include mobile {
                display: none;
            }
        }

        &-banner {
            &-inner {
                height: 350px;
                border-radius: var(--br-1);
                overflow: hidden;
                background-position: center center;
                background-size: cover;
                background-repeat: no-repeat;

                @include tablet {
                    max-height: 227px;
                }
            }

            &-content {
                width: 100%;
                height: 100%;
                padding: 34px;
                position: relative;

                @include tablet {
                    padding: 20px;
                }

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                    background: linear-gradient(124.11deg, #FFFFFF 8.54%, rgba(255, 255, 255, 0) 64.65%);
                    opacity: 0.4;
                }

                &-inner {
                    position: relative;
                    z-index: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;
                }
            }

            &-title {
                font-weight: 600;
                font-size: 32px;
                line-height: 42px;
                font-family: var(--font-secondary);
                color: var(--c-gray-100);

                @include tablet {
                    font-size: 22px;
                    line-height: 28px;
                }
            }

            &-text {
                font-family: var(--font-secondary);
                color: var(--c-gray-100);
                font-weight: 500;
                font-size: 18px;
                line-height: 28px;
                max-width: 330px;
                margin-top: 10px;
                @include tablet {
                    font-size: 12px;
                    line-height: 16px;
                    margin-top: 6px;
                    max-width: 200px;
                }
            }

            &-btn {
                width: 210px;
            }
        }
    }

    &__dropdown {
        position: absolute;
        top: 90px;
        left: 0;
        width: 100%;
        padding: 0 44px;
        z-index: 100;
        transition: all .3s ease .3s;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;

        @include tablet {
            padding: 0;
            top: calc(100% + 1px);
        }

        @include mobile {
            top: 0;
            padding: 0;
            height: 100%;
            opacity: 1;
            visibility: visible;
            transition: all .3s ease 0s;
            transform: translate(-100%, 0);
            &.active {
                transform: translate(0, 0);
            }
        }

        &-inner {
            background: #fff;
            width: 100%;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            overflow: hidden;
            padding: 56px;
            max-width: 1500px;
            margin: 0 auto;
            pointer-events: all;

            @include tablet {
                border-radius: 0;
                padding: 38px 15px;
                box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 4px 8px rgba(0, 0, 0, 0.08);
            }

            @include mobile {
                background: var(--c-gray-800);
                border-radius: 0;
                height: 100%;
                padding: 0;
                overflow: auto;
                box-shadow: 0 20px 24px rgba(0, 0, 0, 0.16);
            }

            &::before {
                content: '';
                position: absolute;
                left: 0;
                width: 100%;
                height: 30px;
                bottom: 100%;
                background: transparent;
            }
        }
    }
}

.langs {
    @include mobile {
        display: none;
    }

    &__current {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        width: 50px;
        height: 50px;
        border-radius: 6px;
        transition: background .3s ease 0s;

        @include tablet {
            width: 30px;
            font-size: 12px;
        }
    }

    &:hover {
        .langs__current {
            background: rgb(233, 235, 237, 0.24);
        }
    }

    &__item {
        color: var(--c-gray-100);
        text-transform: uppercase;
        font-weight: 600;
        font-size: 14px;
    }
}

.dropdown {
    position: relative;

    &__btn {
        cursor: pointer;
    }

    &__panel {
        position: absolute;
        left: 0;
        top: calc(100% + 4px);
        opacity: 0;
        visibility: hidden;
        transition: all .3s ease;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: -4px;
            height: 4px;
            width: 100%;
            background: transparent;
        }

        &-inner {
            background: #fff;
            box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(0, 0, 0, 0.03);
            border-radius: var(--br-1);
            overflow: hidden;
        }
    }

    &:hover {
        .dropdown__panel {
            opacity: 1;
            visibility: visible;
        }
    }

    &__item {
        display: flex;
        padding: 12px 16px;
        transition: all .3s ease;

        &:hover {
            background: var(--c-gray-700);
        }
    }
}

.header__user-menu{
    width: 17em;
    position: absolute;
    top: 4em;
}

@media (max-width: 960px) {
  .header__user-menu{
    z-index: 100;
    width: 100vw;
    height: 70vh;
    position: absolute;
    top: 46vh;
    bottom: 0;
    right: 0;
    left: 0;
  }
}

@media (max-width: 900px) {
  .header__user-menu{
    z-index: 100;
    width: 100vw;
    height: 70vh;
    position: absolute;
    top: 40vh;
    bottom: 0;
    right: 0;
    left: 0;
  }
}

@media (max-width: 700px) {
  .header__user-menu{
    z-index: 100;
    width: 100vw;
    height: 70vh;
    position: absolute;
    top: 24vh;
    bottom: 0;
    right: 0;
    left: 0;
  }
}

.header__user-menu .aside-nav__item {
    position: relative;
}

</style>
